import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, Typography, useTheme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { UIContext } from '../../context/UIContext';
import { StepContext } from '../../context/StepContext';
import PageHeader from '../../components/pageHeaderComponents/PageHeader';
import ActionsContainer from '../../components/ActionsContainer';
import usePageTitle from '../../helperHooks/usePageTitle';

const ProductsChoice = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { colorMode, isMediumDevice } = useContext(UIContext);
  const { goToPreviousStep, goToNextStep } = useContext(StepContext);

  usePageTitle('nav.products');

  return (
    <>
      <PageHeader />

      <Box
        sx={{
          display: 'flex',
          flexDirection: !isMediumDevice ? 'column' : 'row',
          flexGrow: 1,
          gap: '1rem',
          flexWrap: 'wrap',
          ...(!isMediumDevice && {
            marginBottom: '4rem',
          }),
        }}
      >
        <Card
          elevation={0}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            ...(isMediumDevice && {
              width: '100%',
              flexBasis: '45%',
            }),

            padding: '1rem',
            cursor: 'pointer',
            border: `1px ${
              colorMode === 'light' ? theme.palette.grey['12p'] : theme.palette.grey['23p']
            } solid`,
            ':hover': {
              backgroundColor:
                colorMode === 'light'
                  ? theme?.palette?.main?.['8p']
                  : theme?.palette?.main?.['26p'],
            },
          }}
          onClick={() => {
            navigate('/products-categories');
          }}
        >
          <Box>
            <Typography variant="h3" sx={{ marginBottom: '0.5rem' }}>
              {t('screens.products.choicePage.manualCardHeader')}
            </Typography>
            <Typography variant="body1">
              {t('screens.products.choicePage.manualCardDescription')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
            <ArrowForwardIcon />
          </Box>
        </Card>
        <Card
          elevation={0}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            ...(isMediumDevice && {
              width: '100%',
              flexBasis: '45%',
            }),
            padding: '1rem',
            cursor: 'pointer',
            border: `1px ${
              colorMode === 'light' ? theme.palette.grey['12p'] : theme.palette.grey['23p']
            } solid`,
            ':hover': {
              backgroundColor:
                colorMode === 'light'
                  ? theme?.palette?.main?.['8p']
                  : theme?.palette?.main?.['26p'],
            },
          }}
          onClick={() => {
            navigate('/products-sidekick');
          }}
        >
          <Box>
            <Typography variant="h3" sx={{ marginBottom: '0.5rem' }}>
              {t('screens.products.choicePage.sidekickCardHeader')}
            </Typography>
            <Typography variant="body1">
              {t('screens.products.choicePage.sidekickCardDescription')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
            <ArrowForwardIcon />
          </Box>
        </Card>

        <Card
          elevation={0}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            ...(isMediumDevice && {
              width: '100%',
              flexBasis: '45%',
            }),
            padding: '1rem',
            cursor: 'pointer',
            border: `1px ${
              colorMode === 'light' ? theme.palette.grey['12p'] : theme.palette.grey['23p']
            } solid`,
            ':hover': {
              backgroundColor:
                colorMode === 'light'
                  ? theme?.palette?.main?.['8p']
                  : theme?.palette?.main?.['26p'],
            },
          }}
          onClick={() => {
            navigate('/products-import');
          }}
        >
          <Box>
            <Typography variant="h3" sx={{ marginBottom: '0.5rem' }}>
              {t('screens.products.choicePage.importCardHeader')}
            </Typography>
            <Typography variant="body1">
              {t('screens.products.choicePage.importCardDescription')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
            <ArrowForwardIcon />
          </Box>
        </Card>
      </Box>

      <ActionsContainer>
        <Button
          variant="outlined"
          sx={{
            margin: '0px',
            flexGrow: '0',
            height: '48px',
          }}
          onClick={goToPreviousStep}
        >
          {t('actions.previous')}
        </Button>
        <Button
          variant="outlined"
          sx={{
            margin: '0px',
            flexGrow: '0',
            height: '48px',
          }}
          onClick={goToNextStep}
        >
          {t('actions.skip')}
        </Button>
      </ActionsContainer>
    </>
  );
};

export default ProductsChoice;
